import { useEffect, useState } from "react";

import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { PromotionForm } from "@/features/promotions";
import { apiClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const EditPromotion = () => {
  const { promotionId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [promotionName, setPromotionName] = useState("");
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchPromotion = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiClient.get(`promotions/${promotionId}`, {
          params: {
            withPromotionCampaign: true,
            withPromotionOutlets: true,
          },
        });

        const outletMap = (data.promotionOutlets || []).reduce((acc, po) => {
          acc[po.outletId] = true;
          return acc;
        }, {});

        setPromotionName(data.name);
        setDefaultValues({
          promotionCampaign: data.promotionCampaign
            ? {
                id: data.promotionCampaignId,
                name: data.promotionCampaign.name,
              }
            : null,
          name: data.name,
          promotionType: data.promotionType,
          discountType: data.discountType,
          discountAmount: data.discountAmount,
          maximumDiscountAmount: data.maximumDiscountAmount ?? "",
          validFrom: dayjs(data.validFrom),
          validTo: dayjs(data.validTo),
          status: data.status,
          globalUsageLimit: data.globalUsageLimit,
          perCustomerLimit: data.perCustomerLimit,
          outlets: outletMap,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPromotion();
  }, [promotionId]);

  const handleSubmit = async (payload) => {
    try {
      await apiClient.put(`promotions/${promotionId}`, payload);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui promosi")
      );
    }
  };

  return isLoading ? (
    <CenteredLoading />
  ) : (
    <PageContainer
      maxWidth="xl"
      title="Edit Promosi"
      breadcrumbs={[
        { title: "Promosi", path: "/setting/promotions" },
        {
          title: promotionName || promotionId,
          path: `/setting/promotions/${promotionId}`,
        },
        { title: "Edit" },
      ]}
    >
      <PromotionForm
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
